module.exports = __webpack_public_path__ + "img/343ddf442b0a79ab03a900489d23504a.4ba2aba0.png";